// 用户类型
export enum UserType {
    '蛋叔员工' = 1,
    '合作商户',
    '渠道方',
    "全部",
    "供应商"
}